module.exports = __webpack_public_path__ + "img/trust.c48b72a7.png";